import {
  Grid,
  InputAdornment,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useQuery } from '@apollo/client';
import { GET_JOB_TITLES } from '../../gql';
import { useEffect, useState } from 'react';
import { IFilterProps } from '../../type';
import MultiSelectAll from '../../../common/widgets/multiSelectAll';

function UserFilter({
  filter,
  setFilter,
  roles,
  departments
}: IFilterProps): JSX.Element {
  const { data: jobTitlesData } = useQuery(GET_JOB_TITLES);
  const designations = ['All', ...(jobTitlesData?.getJobTitles ?? [])];

  const [selectedRoles, setSelectedRoles] = useState<string[]>(['All']);
  const [selectedDepartments, setSelectedDepartments] = useState<string[]>([
    'All'
  ]);

  useEffect(() => {
    setSelectedRoles(['All', ...roles.map((role) => role.id)]);
    setSelectedDepartments([
      'All',
      ...departments.map((department) => department.id)
    ]);
  }, [roles, departments]);

  useEffect(() => {
    setFilter({
      ...filter,
      roles: selectedRoles,
      departments: selectedDepartments
    });
  }, [selectedRoles, selectedDepartments]);

  return (
    <Grid
      container
      spacing={2}
      sx={{ width: '100%', height: 'auto', maxWidth: '1600px' }}
    >
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          placeholder="Search by Name"
          fullWidth
          variant="outlined"
          value={filter.name ?? ''}
          onChange={(e) => setFilter({ ...filter, name: e.target.value })}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              maxHeight: '48px',
              fontSize: '16px',
              '& .MuiOutlinedInput-input::placeholder': {
                fontFamily: 'Be Vietnam Pro',
                fontSize: '16px',
                fontWeight: '500',
                color: '#5F6368',
                opacity: 1
              }
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <FormControl
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              maxHeight: '48px',
              fontSize: '16px'
            }
          }}
          fullWidth
        >
          <InputLabel
            sx={{
              fontFamily: 'Be Vietnam Pro',
              fontSize: '16px',
              fontWeight: '500',
              color: '#5F6368',
              opacity: 1
            }}
          >
            Designation
          </InputLabel>
          <Select
            value={filter.designation ?? ''}
            label="Designation"
            onChange={(e) =>
              setFilter({ ...filter, designation: e.target.value })
            }
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                  '&::-webkit-scrollbar': {
                    width: '7px',
                    background: 'rgba(217, 217, 217, 0.51)'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    borderRadius: '10px',
                    backgroundColor: '#aaa'
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#999'
                  }
                },
                style: {
                  width: 'auto'
                }
              }
            }}
          >
            {designations.map((designation: string) => (
              <MenuItem key={designation} value={designation}>
                {designation}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <MultiSelectAll
          placeholder="System Role"
          menuItems={[{ displayName: 'All', id: 'All' }, ...roles]}
          selected={selectedRoles}
          setSelected={setSelectedRoles}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <MultiSelectAll
          placeholder="Department"
          menuItems={[{ displayName: 'All', id: 'All' }, ...departments]}
          selected={selectedDepartments}
          setSelected={setSelectedDepartments}
        />
      </Grid>
    </Grid>
  );
}

export default UserFilter;
